/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type AdvancedAssignmentFilterOption =
  (typeof AdvancedAssignmentFilterOption)[keyof typeof AdvancedAssignmentFilterOption];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdvancedAssignmentFilterOption = {
  ShowOnlyCompletedAssignments: 1,
  OnlyIncludeBookedHomeDeliveriesToCustomer: 2,
  ExcludeFurtherTransport: 3,
  HasAssignee: 4,
  FromStrangnasLogistik: 5,
  ToStrangnasLogistik: 6,
  IncludePlaceholderAndTransportAssignments: 7,
  IncludeOnlyUninvoicedCases: 8,
  VehicleIsRiskVehicle: 9,
  VehicleIsSupercar: 10,
  VehicleIsPremiumCar: 11,
  VehicleIsHighMileage: 12,
  VehicleIsOlderModel: 13,
  VehicleIsTransportVehicle: 14,
  VehicleIsElectric: 15,
  IncludeAllStopovers: 16,
  VehicleIsLowRangeElectric: 17,
} as const;
